import React from 'react'
import {Box, Stack} from '@mui/material'
import WelcomeBanner from '@containers/dashboard/banner/WelcomeBanner'
import DashboardKpis from '@containers/dashboard/kpi/DashboardKpis'
import ActivityCard from '@containers/dashboard/activity/ActivityCard'
import NewsCard from '@containers/dashboard/news/NewsCard'
import SessionsCard from '@containers/dashboard/sessions/SessionsCard'
import SettingsCard from '@containers/dashboard/settings/SettingsCard'
import {useDashboardInfoQuery, useDashboardVoyagesQuery} from '@containers/dashboard/queryHooks/useDashboardQuery'
import {useGetDeviceActivityQuery} from '@containers/device/containers/deviceActivity/fetchingData/useDeviceActivityQuery'

const Dashboard = () => {
	const {data: info} = useDashboardInfoQuery()
	const {data: activity} = useGetDeviceActivityQuery()
	const {data: voyages} = useDashboardVoyagesQuery()

	return (
		<Box
			sx={{
				display: 'grid',
				gap: '12px',
				gridTemplateColumns: {xs: '1fr', md: 'repeat(3, minmax(0, 1fr))'},
				alignItems: 'start',
				maxWidth: 1400,
				width: '100%',
				mx: 'auto',
				p: {xs: '8px', md: '16px'},
				boxSizing: 'border-box',
			}}
		>
			<WelcomeBanner info={info}/>
			<DashboardKpis info={info} activity={activity} voyages={voyages}/>
			{/* Two independent columns; news stretches to the height of the right one. */}
			<Box
				sx={{
					gridColumn: '1 / -1',
					display: 'grid',
					gap: '12px',
					gridTemplateColumns: {xs: '1fr', md: 'minmax(0, 2fr) minmax(0, 1fr)'},
					alignItems: {xs: 'start', md: 'stretch'},
				}}
			>
				<Stack gap={'12px'} minWidth={0}>
					<ActivityCard data={activity}/>
					<NewsCard/>
				</Stack>
				<Stack gap={'12px'} minWidth={0}>
					<SettingsCard info={info}/>
					<SessionsCard/>
				</Stack>
			</Box>
		</Box>
	)
}

export default Dashboard
